<template>
    <div>

        <Header @func="getMsgFormSon"></Header>


        <div style="display: flex;">
            <!--      内容区域-->
            <router-view style="flex: 1"/>
        </div>
    </div>
</template>

<script>
    import Header from "../EN/Header";


    export default {
        name: "layout",
        components:{
            Header
        },
        created() {

            if (this.$route.path.indexOf("/Calc")!=-1){
                this.ulisShow=false
            }
        },
        data(){
           return {
               phone:false,
               message:false,
               position:false,
               ulisShow:false
           }
        },
        methods:{
            getMsgFormSon(data){

                this.ulisShow=data
            }
        }
    }
</script>

<style scoped>
    .el-button{
        height: 48px;
        width: 48px;
        font-size: 20px;

    }
    .el-button:hover{
        /*background-color: ;*/

        /*background: #09f;*/
        background-image: linear-gradient(45deg, #0081ff, #1cbbb4);
        color: white;
        border: 0px solid;
        height: 54px;
        width: 54px;

    }
    ul{
        position: absolute;
        top:50%;
        margin-top: -79px;
        z-index: 999;
        padding-left: 20px;
    }
    li{

        margin-top: 5px;
        list-style: none;

    }
    li a{
        border: 1px solid #808080;
        height: 46px;
        line-height: 46px;
        display: inline-block;
        border-radius: 50px;
        padding: 0 15px;
        margin-left: 5px;
        background-color: white;
    }
    .slide-fade-enter-active {transition: all .2s ease;}
    .slide-fade-leave-active {transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);}
    .slide-fade-enter{transform: translateY(-100px);opacity: 0;}
    .slide-fade-leave-to{transform: translateX(100px);opacity: 0;}

</style>